import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AttachDocumentsComponent } from '../identification/attach-documents/attach-documents.component';
import { DocumentRequirementsComponent } from '../identification/document-requirements/document-requirements.component';
import { PortalOperatorSummaryComponent } from '../identification/portal-operator-summary/portal-operator-summary.component';

import { AgreementsFilterComponent } from './agreements-filter/agreements-filter.component';
import { DocumentIntroductionComponent } from './document-introduction/document-introduction.component';
import {
  LegalRequirementsCharacteristicsComponent,
} from './legal-requirements-characteristics/legal-requirements-characteristics.component';
import { LegalRequirementsComponent } from './legal-requirements/legal-requirements.component';
import { PrioritizeProductsComponent } from './prioritize-products/prioritize-products.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { ProductInfoComponent } from './product-info/product-info.component';
import { ProductSelectionComponent } from './product-selection/product-selection.component';
import { SelectedProductDetailComponent } from './selected-product-detail/selected-product-detail.component';
import { CaptureDataComponent } from '../capture/capture-data/capture-data.component';

const routes: Routes = [
  {
    path: 'product-selection',
    component: ProductSelectionComponent,
  },
  {
    path: 'selected-product-detail',
    component: SelectedProductDetailComponent,
  },
  {
    path: 'product-detail',
    component: ProductDetailComponent,
  },
  {
    path: 'capture-data',
    component: CaptureDataComponent,
  },
  {
    path: 'document-introduction',
    component: DocumentIntroductionComponent,
  },
  {
    path: 'agreement-filter',
    component: AgreementsFilterComponent,
  },
  {
    path: 'product-info',
    component: ProductInfoComponent,
  },
  {
    path: 'legal-requirements',
    component: LegalRequirementsComponent,
  },
  {
    path: 'legal-requirements-characteristics',
    component: LegalRequirementsCharacteristicsComponent,
  },
  {
    path: 'prioritize-products',
    component: PrioritizeProductsComponent,
  },
  {
    path: 'portal-operator-summary',
    component: PortalOperatorSummaryComponent,
  },
  {
    path: 'attach-documents',
    component: AttachDocumentsComponent,
  },
  {
    path: 'document-requirements',
    component: DocumentRequirementsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class ProductSelectionRoutes { }
